import { render, staticRenderFns } from "./FormObject.vue?vue&type=template&id=5ad98479&"
import script from "./FormObject.vue?vue&type=script&lang=js&"
export * from "./FormObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports